import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h5 fw-bold mb-3" }
const _hoisted_2 = { style: {"background-color":"#ebfff2","padding":"20px","margin-bottom":"20px","border-radius":"4px","box-shadow":"0 1px 3px rgba(0, 0, 0, 0.1)","display":"flex","align-items":"center","justify-content":"flex-start","min-height":"120px"} }
const _hoisted_3 = {
  class: "text-start",
  style: {"margin":"0"}
}
const _hoisted_4 = { style: {"font-size":"20px","margin":"0 0 6px 0"} }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t(`project.previewAndReport.reportTypes.${_ctx.reportType}.price.title`)), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", {
            innerHTML: 
            _ctx.$t(
              `project.previewAndReport.reportTypes.${_ctx.reportType}.price.totalPrice`,
              {
                price: ` <span style='color: var(--description-color);'>${new Intl.NumberFormat('en-EU', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(_ctx.projectData?.financial_data?.final_price || 0)}</span>`,
                IVApercentage: _ctx.reportType && _ctx.reportType.startsWith('complete_solution') ? '10%' : '',
              }
            )
          
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("p", {
          style: {"font-size":"12px","margin":"0"},
          innerHTML: 
            _ctx.$t(
              `project.previewAndReport.reportTypes.${_ctx.reportType}.price.financingNote`,
              {
                years: Math.round(
                  (_ctx.projectData?.financial_data?.installment_duration_months ||
                    120) / 12
                ),
              }
            )
          
        }, null, 8, _hoisted_6)
      ])
    ])
  ]))
}